import Icon from '@ant-design/icons';
import { AlertProps as AntdAlertProps } from 'antd';
import CloseSvg from 'global/Icons/CloseSvg';
import { BaseAlert } from './styled';

type AlertProps = AntdAlertProps;

const Alert = (props: AlertProps) => (
  <BaseAlert
    closeText={
      <Icon component={CloseSvg} style={{ color: '#969696', fontSize: 10 }} />
    }
    {...props}
  />
);

export default Alert;
